e4.bootstrap.dropdown = {
    init: function () {
        e4.bootstrap.dropdown.bindEvents();
    },
    bindEvents: function () {
        //Prevent dropdown menu from closing when clicking child nodes.
        jQuery( '.dropdown-menu' ).on( 'click.bs.dropdown.data-api', function ( event ) {
            if ( jQuery( this ).parent().hasClass( 'open' ) === true && event.target.getAttribute( 'data-toggle' ) !== 'dropdown' && event.target.parentNode.getAttribute( 'data-toggle' ) !== 'dropdown' ) {
                event.stopPropagation();
            }
        } );
    }
};

